import axiosInstance from "../axiosClient";

export const getCallLogs = async (limit = 40, start_key = "") => {
  const params = { limit };
  if (start_key) params.start_key = start_key;
  return axiosInstance.get("admins/call_logs", { params });
};
